export const MuiPaper = {
    styleOverrides: {
        root: {
            '& .MuiPickersLayout-contentWrapper':{
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            '& .MuiDateCalendar-root':{
                maxHeight: '330px',
                alignItems: 'center'
            },
            '& .MuiPickersCalendarHeader-root':{
                color: 'var(--mui-palette-primary-textColor)',
                '& .MuiPickersArrowSwitcher-root': {
                    display: 'none'
                }
            },
            '& .MuiDayCalendar-header > span': {
                color: 'var(--mui-palette-secondary-textIconColor)'
            },
            '& .MuiPickersYear-root, & .MuiMonthCalendar-root':{
                '& button':{
                    borderRadius: 8,
                    color: 'var(--mui-palette-primary-textColor)',
                    '&.Mui-disabled':{
                        color: 'var(--mui-palette-texts-darkIcons)'
                    },
                    '&.Mui-selected, &:hover':{
                        backgroundColor: 'var(--mui-palette-primary-main)',
                        color: 'var(--mui-palette-primary-textButtonColor)',
                    }
                }
            },
            '& .MuiDayCalendar-root':{
                '& button':{
                    color: 'var(--mui-palette-primary-textColor)',
                    backgroundColor: 'var(--mui-palette-secondary-main)',
                    '&.Mui-disabled':{
                        color: 'var(--mui-palette-texts-darkIcons)'
                    },
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '& .MuiYearCalendar-root':{
                marginLeft: 8
            }

        }
    }
}
